import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import myImage from "../../../src/assets/images/thank-you-logo.png";
import checkThank from "../../../src/assets/icons/check-thank.svg";
// import puravankarLogo from "../../../src/assets/icons/purva-logo-white.png";
import puravankarLogo from "../../../src/assets/images/thank-you-logo.png";
// import ProvidentLogo from "../../../src/assets/images/Provident Reverse logo.png";
import ProvidentLogo from "../../../src/assets/icons/Provident.svg";

// import PurvaLandLogo from "../../../src/assets/images/PurvaLand Master Logo reverse.png";
import PurvaLandLogo from "../../../src/assets/icons/Purva Land 1.svg";

import "./FeedbackModal.scss";
import { Typography } from "@mui/material";
import {
  getApplicantDetails,
  getMasterDataList,
  getOppprtunityDetails,
  setActiveStep,
  setApplicantTotal,
  setIsFromPreview,
  setIsLoading,
  setProjectBrandImage,
  setResetData,
} from "../new-booking-form/new-booking-form.slice";
import { GET } from "../../services/axiosInstance";
import { route } from "../../services/apiRoutes";
import { COMPARE_VALUE } from "../../config/constant";
import { useHandleRedirection } from "../new-booking-form/hooks/useHandleRedirection";
const { REACT_APP_BRANDLOGO_URL } = process.env;

const FormSubmitThankYou = () => {
  const { oppId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { handleRedirection } = useHandleRedirection();


  const { projectBrandImage, isFromPreview, enquiryDetails, applicantData, applicantEditPreview } = useSelector(
    (state) => state?.newBookingForm
  );

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };


  const getTermsAndCondition = async (data) => {
    try {
      const res = await GET(
        route.GET_TERMS_AND_CONDITION,
        `/${data?.ProjectName}/${data?.projectBrandName}`
      );
      if (res?.response?.success) {
        dispatch(setIsLoading(true));
        let imageUrl = res?.response?.response?.data?.brandLogo || "";
        dispatch(setProjectBrandImage(imageUrl));
        dispatch(setIsLoading(false));
      }
    } catch (error) {
      dispatch(setProjectBrandImage(""));
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (applicantData?.opportunityId !== oppId) {
      dispatch(setResetData());
    }
  }, []);
  
  useEffect(() => {
    if (oppId?.length > 0) {
      dispatch(getOppprtunityDetails(`/${oppId}`))
        .unwrap()
        .then((res) => {
          if (res?.data !== null) {
            getTermsAndCondition(res?.data);
          }
        })
        .catch((error) => { });
      dispatch(getMasterDataList());
      dispatch(getApplicantDetails(`/${oppId}`))
        .unwrap()
        .then((res) => {
          if (res) {
            handleRedirection(res, "");
          }
          if (res?.signedPdf === null) {
            if (res?.leegalityData?.isSignLater === true) {
              // history.push(`/customer-preview/${oppId}`);
            } else {
              dispatch(setApplicantTotal(res?.noOfApplicants));
              if (!isFromPreview?.value) {
                dispatch(setActiveStep(res?.lastStep));
              } else {
                dispatch(setActiveStep(isFromPreview?.index));
                dispatch(setIsFromPreview({ value: false, index: null }));
              }
            }
          }
        })
        .catch((error) => {
          dispatch(setResetData());
          history.push(`/booking-form/${oppId}`)

          // if (!error?.message?.includes("Booking with Opportunity")) {
          //   setSnackBarconfig({
          //     open: true,
          //     message: ERROR_MESSAGE,
          //     severity: "error",
          //   });
          // }
        });
    }
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url("${REACT_APP_BRANDLOGO_URL + "/" + projectBrandImage
          }")`,
      }}
      className="modalCustomFeedback height100 applicantBackground"
    >
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className={`modalCustomFeedbackContent modalCustomFeedbackContentTHANKYOU width642`}>
        {/* <span className="customClose">
          <HighlightOffIcon />
        </span> */}
        <div className="logoFeedback">
          <img src={getBrandImage()} alt="Logo" />
        </div>
        <div className="checkThank">
          <img src={checkThank} alt="" />
        </div>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#1C252E",
            mb: 1,
            textAlign: "center",
          }}
        >
          Thank you!
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#1C252E",
            lineHeight: "22px",
            mb: "29px",
            textAlign: "center",
          }}
          className=""
        >
          {/* <p>You have already signed and submitted the application form.</p>
          <p>
            The signed PDF has been emailed to all applicants for your records.
          </p>
          <p>
            If you have any questions or need further assistance, feel free to
            reach out to us.
          </p> */}
          <p>You have already signed and submitted the application form.

            The signed PDF has been emailed to all applicants for your records.


            If you have any questions or need further assistance, feel free to
            reach out to us.
          </p>
        </Typography>
      </div>
    </div>
  );
};

export default FormSubmitThankYou;
